let observerOptions = {
  rootMargin: "0px",
  threshold: 0.2
};

const observer = new IntersectionObserver(observerCallback, observerOptions);

function observerCallback(entries, observer) {
  entries.forEach((entry) => {
    if (entry.isIntersecting) {
      gsap.fromTo(
        entry.target.querySelectorAll(".section-heading, .section-subheading, .section-content, .grid-item, .button, video"),
        { autoAlpha: 0, transform: `translateY(3rem)` },
        { autoAlpha: 1, transform: `translateY(0)`, stagger: 0.1, duration: 0.45, ease: "power2.inOut" }
      );
      observer.unobserve(entry.target);
    }
  });
}

// Doesn't set up the observers to respect prefers reduced motion by adding a class to the HTML and showing elements in css
if (!window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
  document.querySelectorAll("section:not(.animations-disabled)").forEach((el) => {
    if (!el) return;
    observer.observe(el);
  });
} else {
  document.documentElement.classList.add("prefers-reduced-motion");
}
